import { Box, IconButton, Typography } from '@mui/material'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { ChangeEvent } from 'react'
import { Page } from 'store/common.types'

type PrevNextPaginationProps = {
  page: Page
  onChange: (event: ChangeEvent<unknown>, page: number) => void
}

const navButtonSx = {
  width: 32,
  height: 32,
  borderRadius: '6px',
  border: '1px solid',
  borderColor: 'grey.300',
  color: 'text.primary',
  bgcolor: 'common.white',
  '&:hover': {
    bgcolor: 'grey.50',
    borderColor: 'grey.400',
  },
  '&.Mui-disabled': {
    borderColor: 'grey.200',
    color: 'action.disabled',
    bgcolor: 'common.white',
  },
}

const PrevNextPagination = ({ page, onChange }: PrevNextPaginationProps) => {
  const current = page.number + 1
  const total = Math.max(page.totalPages, 1)

  const goTo = (next: number) => {
    if (next < 1 || next > total || next === current) return
    onChange({} as ChangeEvent<unknown>, next)
  }

  return (
    <Box display="flex" alignItems="center" gap={0.75} sx={{ flexShrink: 0 }}>
      <IconButton
        aria-label="Previous page"
        onClick={() => goTo(current - 1)}
        disabled={current <= 1}
        size="small"
        sx={navButtonSx}
      >
        <ChevronLeftIcon fontSize="small" />
      </IconButton>
      <Typography
        sx={{
          fontWeight: 500,
          fontSize: 13,
          minWidth: 44,
          textAlign: 'center',
          color: 'text.secondary',
          whiteSpace: 'nowrap',
        }}
      >
        {current} of {total}
      </Typography>
      <IconButton
        aria-label="Next page"
        onClick={() => goTo(current + 1)}
        disabled={current >= total}
        size="small"
        sx={navButtonSx}
      >
        <ChevronRightIcon fontSize="small" />
      </IconButton>
    </Box>
  )
}

export default PrevNextPagination
